module.exports = {
	"id": "IN",
	"name": "India",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.004236,
			"5": 0.006354,
			"6": 0.008472,
			"7": 0.004236,
			"8": 0.006354,
			"9": 0.004236,
			"10": 0.008472,
			"11": 0.014826,
			"12": 0.01059,
			"13": 0.004236,
			"14": 0.008472,
			"15": 0.006354,
			"16": 0.006354,
			"17": 0.008472,
			"18": 0.014826,
			"19": 0.014826,
			"20": 0.014826,
			"21": 0.01059,
			"22": 0.016944,
			"23": 0.016944,
			"24": 0.01059,
			"25": 0.023298,
			"26": 0.012708,
			"27": 0.02118,
			"28": 0.04236,
			"29": 0.025416,
			"30": 0.023298,
			"31": 0.230862,
			"32": 0.016944,
			"33": 0.06354,
			"34": 0.01059,
			"35": 0.01059,
			"36": 0.01059,
			"37": 0.008472,
			"38": 0.016944,
			"39": 0.019062,
			"40": 0.02118,
			"41": 0.016944,
			"42": 0.012708,
			"43": 0.059304,
			"44": 0.023298,
			"45": 0.019062,
			"46": 0.057186,
			"47": 0.036006,
			"48": 0.036006,
			"49": 0.870498,
			"50": 0.059304,
			"51": 0.260514,
			"52": 0.199092,
			"53": 8.472,
			"54": 1.978212,
			"55": 0.09531,
			"56": 0.025416,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.080484,
			"4": 0.008472,
			"5": 0.004236,
			"6": 0.004236,
			"7": 0.004236,
			"8": 0.004236,
			"9": 0.004236,
			"10": 0.008472,
			"11": 0.01059,
			"12": 0.016944,
			"13": 0.008472,
			"14": 0.01059,
			"15": 0.01059,
			"16": 0.012708,
			"17": 0.008472,
			"18": 0.008472,
			"19": 0.008472,
			"20": 0.01059,
			"21": 0.012708,
			"22": 0.012708,
			"23": 0.008472,
			"24": 0.008472,
			"25": 0.006354,
			"26": 0.006354,
			"27": 0.008472,
			"28": 0.016944,
			"29": 0.02118,
			"30": 0.014826,
			"31": 0.065658,
			"32": 0.01059,
			"33": 0.016944,
			"34": 0.014826,
			"35": 0.02118,
			"36": 0.014826,
			"37": 0.02118,
			"38": 0.03177,
			"39": 0.025416,
			"40": 0.023298,
			"41": 0.023298,
			"42": 0.023298,
			"43": 0.101664,
			"44": 0.076248,
			"45": 0.072012,
			"46": 0.044478,
			"47": 0.268986,
			"48": 0.199092,
			"49": 1.65204,
			"50": 0.347352,
			"51": 0.004236,
			"52": null,
			"3.5": 0.006354,
			"3.6": 0.014826
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.004236,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.004236,
			"29": 0.004236,
			"30": 0.008472,
			"31": null,
			"32": 0.006354,
			"33": null,
			"34": 0.014826,
			"35": 0.004236,
			"36": 0.014826,
			"37": 0.08472,
			"38": 0.006354,
			"39": 0.008472,
			"40": 0.188502,
			"41": 0.027534,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.004236,
			"12.1": 0.01059
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.002118,
			"6": null,
			"7": 0.006354,
			"8": 0.014826,
			"9": 0.012708,
			"10": 0.080484,
			"3.1": null,
			"3.2": null,
			"5.1": 0.006354,
			"6.1": null,
			"7.1": 0.002118,
			"9.1": 0.050832
		},
		"ios_saf": {
			"8": 0,
			"10": 1.1098101632,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0299080997086,
			"8.1-8.4": 0.0552539469192,
			"9.0-9.2": 0.0263596810991,
			"9.3": 0.402154109076
		},
		"android": {
			"3": 0,
			"4": 0.038916255814,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00486453197674,
			"4.1": 0.140376494186,
			"4.2-4.3": 0.350941235465,
			"4.4": 0.804732575581,
			"4.4.3-4.4.4": 0.811681906977
		},
		"ie": {
			"6": 0.00639310153846,
			"7": 0.00426206769231,
			"8": 0.181137876923,
			"9": 0.0468827446154,
			"10": 0.0660620492308,
			"11": 0.38784816,
			"5.5": null
		},
		"op_mob": {
			"0": 0.642410625578,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0178447395994
		},
		"edge": {
			"12": 0.036006,
			"13": 0.069894,
			"14": 0.08472
		},
		"ie_mob": {
			"10": 0.119658,
			"11": 0.487179
		},
		"bb": {
			"7": 0.02167275,
			"10": null
		},
		"samsung": {
			"0": 2.009655
		},
		"and_uc": {
			"0": 45.032034
		},
		"op_mini": {
			"0": 8.65508663482
		},
		"and_chr": {
			"0": 18.958215
		},
		"and_ff": {
			"0": 0.015762
		}
	},
	"total": 97.58502075
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/IN.json
 ** module id = 551
 ** module chunks = 0
 **/